import styled from 'styled-components'

import { Flex } from '../../../App/Components'

export const Feature = styled.div<{
  fontColor?: string
  fontStyle?: string
}>`
  font-family: Myriad Pro, sans-serif;
  font-size: 1rem;
  letter-spacing: 0.1rem;
  line-height: 1.7;
  margin: 0.5rem 1.1rem;
  justify-content: left;
  color: ${({ fontColor }) => (fontColor ? fontColor : 'inherit')};
  font-style: ${({ fontStyle }) => (fontStyle ? fontStyle : 'inherit')};
  white-space: nowrap;
`
